const mutationTypes = {
  SET_AUDIT: 'SET_AUDIT',
  SET_PREPARABLE_DEFICIENCIES_SETS: 'SET_PREPARABLE_DEFICIENCIES_SETS',
  SET_PREPARABLE_DEFICIENCIES: 'SET_PREPARABLE_DEFICIENCIES'
}

const actionTypes = {
  FETCH_AUDIT: 'FETCH_AUDIT',
  UPDATE_AUDIT: 'UPDATE_AUDIT',
}

export { mutationTypes, actionTypes }



// WEBPACK FOOTER //
// ./src/store/modules/AuditEditTypes.js